import React from "react";
import { Button, Tooltip } from "antd";
import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SoundBasic = ({ onClick, chosen, play }) => {
  // -------------------------- VAR -----------------------------
  const icon =
    play && chosen ? <PauseCircleOutlined /> : <PlayCircleOutlined />;
  const title = play && chosen ? "Ngưng" : "Nghe lại";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title={title}>
      <Button
        onClick={onClick}
        size="small"
        type="text"
        shape="circle"
        icon={icon}
      />
    </Tooltip>
  );
};
export default SoundBasic;
